import Vue from 'vue';
import ApiClient from "@/libs/api_client";

export default {
  strict: true,
  namespaced: true,
  state: {
    layers: {
      humidity: {
        targetList: [],
        minValue: 0,
        maxValue: 0,
        lineInterval: 0,
      },
      temperature: {
        targetList: [],
        minValue: 0,
        maxValue: 0,
        lineInterval: 0,
      },
      light: {
        targetList: [],
        minValue: 0,
        maxValue: 0,
        lineInterval: 0,
      },
    },
  },
  mutations: {
    setTargetList(state, { layerType, value }) {
      const layer = state.layers[layerType];
      Vue.set(layer, 'targetList', value == null ? [] : value);
    },
    setMinValue(state, { layerType, value }) {
      const layer = state.layers[layerType];
      Vue.set(layer, 'minValue', value);
    },
    setMaxValue(state, { layerType, value }) {
      const layer = state.layers[layerType];
      Vue.set(layer, 'maxValue', value);
    },
    setLineInterval(state, { layerType, value }) {
      const layer = state.layers[layerType];
      Vue.set(layer, 'lineInterval', value);
    },
  },
  actions: {
    async getHumidityThings({ commit, rootState }) {
      commit('dialog/startLoad', null, { root: true });

      try {
        const things = await ApiClient.getFloorHumidityThings(
          rootState.current.floorId
        );
        const hasReportedThings = things.filter(
          (thing) => thing.thingState.reported
        );
        commit("setTargetList", { layerType: 'humidity', value: hasReportedThings });
      } finally {
        commit('dialog/finishLoad', null, { root: true });
      }
    },
    async getTemperatureThings({ commit, rootState }) {
      commit('dialog/startLoad', null, { root: true });

      try {
        const things = await ApiClient.getFloorTemperatureThings(
          rootState.current.floorId
        );
        const hasReportedThings = things.filter((thing) => thing.thingState.reported);
        commit("setTargetList", { layerType: 'temperature', value: hasReportedThings });
      } finally {
        commit('dialog/finishLoad', null, { root: true });
      }
    },
    async getLightThings({ commit, rootState }) {
      commit('dialog/startLoad', null, { root: true });

      try {
        const things = await ApiClient.getFloorLightThings(
          rootState.current.floorId
        );
        const hasReportedThings = things.filter(
          (thing) => thing.thingState.reported
        );
        commit("setTargetList", { layerType: 'light', value: hasReportedThings });
      } finally {
        commit('dialog/finishLoad', null, { root: true });
      }
    },
    async getSeasonalTemperatureSetting({ commit }) {
      commit('dialog/startLoad', null, { root: true });

      try {
        const seasonSetting = await ApiClient.getSeasonSettingToday();
        const minTemperature = seasonSetting.minTemperature;
        const maxTemperature = seasonSetting.maxTemperature;

        commit("setMinValue", { layerType: 'temperature', value: minTemperature });
        commit("setMaxValue", { layerType: 'temperature', value: maxTemperature });
      } finally {
        commit('dialog/finishLoad', null, { root: true });
      }
    },
    async getHumidityThingsInBackground({ commit, rootState }) {
      const things = await ApiClient.getFloorHumidityThings(
        rootState.current.floorId
      );
      const hasReportedThings = things.filter(
        (thing) => thing.thingState.reported
      );
      commit("setTargetList", { layerType: 'humidity', value: hasReportedThings });
    },
    async getTemperatureThingsInBackground({ commit, rootState }) {
      const things = await ApiClient.getFloorTemperatureThings(
        rootState.current.floorId
      );
      const hasReportedThings = things.filter((thing) => thing.thingState.reported);
      commit("setTargetList", { layerType: 'temperature', value: hasReportedThings });
    },
    async getLightThingsInBackground({ commit, rootState }) {
      const things = await ApiClient.getFloorLightThings(
        rootState.current.floorId
      );
      const hasReportedThings = things.filter(
        (thing) => thing.thingState.reported
      );
      commit("setTargetList", { layerType: 'light', value: hasReportedThings });
    },
    async getSeasonalTemperatureSettingInBackground({ commit }) {
      const seasonSetting = await ApiClient.getSeasonSettingToday();
      const minTemperature = seasonSetting.minTemperature;
      const maxTemperature = seasonSetting.maxTemperature;

      commit("setMinValue", { layerType: 'temperature', value: minTemperature });
      commit("setMaxValue", { layerType: 'temperature', value: maxTemperature });
    }
  },
};



// WEBPACK FOOTER //
// ./src/stores/map/models/visualization.js